import { PHONE, locationSchema } from "../structured-data-core";

export function getWhitePlainsStructuredData() {
  const url = "https://restorehair.com/locations/new-york/white-plains/";
  const description =
    "Find out about your hair transplant options in White Plains with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("White Plains", "50 Main Street", "White Plains", "NY", PHONE, url, description),
  ];
}
